export const filterTokens = {
  minColumnWidth: 180,
  labelOffsetX: 10,
  labelOffsetY: 9,
  inputPaddingLeft: 8,
  selectPaddingLeft: 2,
  dateInputPaddingLeft: 4,
  controlMinHeight: 34,
  optionRowMinHeight: 32,
  optionCountFontSize: 11,
} as const;
